import { mode } from '@chakra-ui/theme-tools';

export const BreadcrumbStyles = {
  baseStyle: props => ({
    color: mode('graphite.500', 'dark.300')(props),
  }),
};
